import { c as _c } from "react/compiler-runtime";
import { VerticalTabs } from "@components/common/tabs/vertical-tabs";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
import { AccountSettingsMobileLayout } from "@pages/account-settings/account-settings-layout/mobile-layout/account-settings-mobile-layout";
import { useAccountSettingsTabs } from "@pages/account-settings/account-settings-utils";
import { CloseAccountSettingsButton } from "@pages/account-settings/close-account-settings-button";
import { NotFoundPage } from "@pages/not-found-page";
import { AccountSettingsTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { BrowserUtils } from "@stellar/utils";
import { useAppSelector } from "@store/store-helper";
import { fetchingUserFlagsSelector } from "@store/user/user-selector";
import { OpenTabEvents } from "@utils/track-event/track-event-list";

/** The layout of account settings */
export function AccountSettingsLayout() {
  const $ = _c(9);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    loggedInUserFetchingStatus
  } = useAppSelector(fetchingUserFlagsSelector);
  const {
    accountSettingsTabs
  } = useAccountSettingsTabs();
  const {
    accountSettingsTab
  } = useAppParams();
  if (accountSettingsTab && !Object.values(AccountSettingsTabs).includes(accountSettingsTab)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NotFoundPage />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minHeight: "100vh",
      width: "100%"
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== accountSettingsTab || $[3] !== accountSettingsTabs || $[4] !== isScreenSmOrSmaller || $[5] !== loggedInUserFetchingStatus) {
    t1 = isScreenSmOrSmaller ? <AccountSettingsMobileLayout tabs={accountSettingsTabs} selectedTabId={accountSettingsTab} /> : accountSettingsTab && <MainPageLayout shouldHideOpenButton={true} shouldShowSidebar={false} topLeftHeaderButton={<CloseAccountSettingsButton />} shouldUseFullBodyLayout={true} shouldShowProgressOverviewMenu={!BrowserUtils.isInIframe()}><VerticalTabs tabs={accountSettingsTabs} tabSelectionHeader="Settings" selectedTabId={accountSettingsTab} isLoading={loggedInUserFetchingStatus === "pending"} trackingEventPageName={OpenTabEvents.openAccountSettingsTab} dataTestId="account-settings-tab" /></MainPageLayout>;
    $[2] = accountSettingsTab;
    $[3] = accountSettingsTabs;
    $[4] = isScreenSmOrSmaller;
    $[5] = loggedInUserFetchingStatus;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <Box sx={t0}>{t1}</Box>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}